"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentSchedule = getPaymentSchedule;
const schedule_row_end_balance_formula_1 = require("./formulas/schedule-row-end-balance-formula");
const schedule_row_interest_amount_formula_1 = require("./formulas/schedule-row-interest-amount-formula");
const schedule_row_payment_amount_formula_1 = require("./formulas/schedule-row-payment-amount-formula");
const schedule_row_principal_amount_formula_1 = require("./formulas/schedule-row-principal-amount-formula");
///////////////////////////
// Function Implementations
///////////////////////////
function getPaymentSchedule(calculateScheduleParams, scheduleParams) {
    const rows = [];
    for (let paymentIndex = 0; paymentIndex < calculateScheduleParams.paymentCount; paymentIndex++) {
        const row = {};
        const previousRow = rows.length == 0 ? null : rows[paymentIndex - 1];
        function getCellParams() {
            return Object.assign({
                paymentIndex,
                previousRow: Object.assign({}, previousRow),
                currentRow: Object.assign({}, row)
            }, calculateScheduleParams);
        }
        row.interestAmount = (0, schedule_row_interest_amount_formula_1.getScheduleRowInterestAmount)(scheduleParams.scheduleRowInterestAmount)(getCellParams());
        row.paymentAmount = (0, schedule_row_payment_amount_formula_1.getScheduleRowPaymentAmount)(scheduleParams.scheduleRowPaymentAmount)(getCellParams());
        row.principalAmount = (0, schedule_row_principal_amount_formula_1.getScheduleRowPrincipalAmount)(scheduleParams.scheduleRowPrincipalAmount)(getCellParams());
        row.endBalance = (0, schedule_row_end_balance_formula_1.getScheduleRowEndBalance)(scheduleParams.scheduleRowEndBalance)(getCellParams());
        rows.push(row);
    }
    return rows;
}
//# sourceMappingURL=payment-schedule.js.map